module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("会员卡售卖 / " + _vm._s(_vm.id ? "编辑" : "新增"))]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "label-width": "96px",
      "label-position": "left",
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入名称",
      "maxlength": _vm.nameMaxLength
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择类型",
      "disabled": _vm.isEdit
    },
    on: {
      "change": _vm.handleTypeChange
    },
    model: {
      value: (_vm.formData.type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "type", $$v)
      },
      expression: "formData.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "售卖卡",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "赠送卡",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预售卡",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "特权角色",
      "prop": "privilegeRoleId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择特权角色",
      "filterable": "",
      "disabled": _vm.isEdit
    },
    model: {
      value: (_vm.formData.privilegeRoleId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "privilegeRoleId", $$v)
      },
      expression: "formData.privilegeRoleId"
    }
  }, _vm._l((_vm.privilegeOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.isPreSale) ? _c('el-form-item', {
    attrs: {
      "label": "会员时长",
      "prop": "timeRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "placeholder": "选择日期范围",
      "format": "yyyy-MM-dd",
      "disabled": _vm.isEdit
    },
    model: {
      value: (_vm.formData.timeRange),
      callback: function($$v) {
        _vm.$set(_vm.formData, "timeRange", $$v)
      },
      expression: "formData.timeRange"
    }
  })], 1) : _c('el-form-item', {
    attrs: {
      "label": "会员时长",
      "prop": "duration"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "min": 1,
      "disabled": _vm.isEdit
    },
    model: {
      value: (_vm.formData.duration),
      callback: function($$v) {
        _vm.$set(_vm.formData, "duration", $$v)
      },
      expression: "formData.duration"
    }
  }), _vm._v(" "), _c('span', [_vm._v("天")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "售卖价格",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "min": 0.01,
      "disabled": _vm.isEdit
    },
    model: {
      value: (_vm.formData.price),
      callback: function($$v) {
        _vm.$set(_vm.formData, "price", $$v)
      },
      expression: "formData.price"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_vm._v("有促销价时,售卖价将作为划线价展示")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序",
      "prop": "sort"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.formData.sort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sort", $$v)
      },
      expression: "formData.sort"
    }
  }), _vm._v(" "), _c('div', [_vm._v("越小越靠前，如一直则新创建的靠前")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赠送体验卡"
    }
  }, [_c('div', {
    staticClass: "flex-column"
  }, _vm._l((_vm.formData.cardConfig), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "flex-row margin-bottom-10"
    }, [_c('el-select', {
      staticStyle: {
        "flex": "1"
      },
      attrs: {
        "placeholder": "请选择体验卡",
        "disabled": _vm.isEdit
      },
      model: {
        value: (item.label),
        callback: function($$v) {
          _vm.$set(item, "label", $$v)
        },
        expression: "item.label"
      }
    }, _vm._l((_vm.experienceOptions), function(card, num) {
      return _c('el-option', {
        key: num,
        attrs: {
          "label": card.label,
          "value": card.value
        }
      })
    }), 1), _vm._v(" "), _c('el-input-number', {
      staticStyle: {
        "width": "100px",
        "margin-left": "10px"
      },
      attrs: {
        "controls": false,
        "min": 1,
        "disabled": _vm.isEdit
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "margin-left-10"
    }, [_vm._v("张")]), _vm._v(" "), _c('el-button', {
      staticClass: "margin-left-10",
      attrs: {
        "type": "danger",
        "icon": "delete",
        "disabled": _vm.isEdit
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteCard(index)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus",
      "disabled": _vm.isEdit
    },
    on: {
      "click": _vm.clickAddCard
    }
  }, [_vm._v("添加类型")])], 1), _vm._v(" "), (_vm.id) ? _c('el-form-item', {
    attrs: {
      "label": "已售"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.formData.usedQuantity))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.clickSave()
      }
    }
  }, [_vm._v("保存")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-337429e1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/MemberSale/MemberSaleDetail.vue
// module id = 984
// module chunks = 0